import i18next from 'i18next';
import { useTranslation } from 'i18next-vue';

import { AppLocale } from '@shared/i18n';

import mainPageRu from './ru.json';
import mainPageKk from './kk.json';

const NAMESPACE_NAME = 'main-page';

export const useMainPageLocales = () => {
  i18next.addResourceBundle(
    i18next.language,
    NAMESPACE_NAME,
    i18next.language === AppLocale.RU ? mainPageRu : mainPageKk,
    true,
  );

  return useTranslation(NAMESPACE_NAME);
};
